export const USER_TYPE = {
    ADMIN: 'A', 
    TECH: 'T', 
    CUSTOMER: 'U',
}

export const PERMISSION_TYPE = {
    READ: 'R',
    WRITE: 'W', 
}

export const LOGIN_VERSION = {
    pci: 'PCI', 
    cloud1x: 'cloud1x',
}

export const STATION_PERMISSIONS = [
    { 
        type: 'superuser',
        permissions: {
            advancedSearch: true,
            station: {
                add: true, 
                edit: true, 
                remove: true, 
                winbox: true,
            } 
        }, 
    }, 
    {
        type: USER_TYPE.ADMIN, 
        permissions: {
            advancedSearch: true,
            station: {
                add: true, 
                edit: true, 
                remove: true, 
                winbox: false
            }, 
        }, 
    }, 
    {
        type: USER_TYPE.TECH, 
        permissions: {
            advancedSearch: true,
            station: {
                add: true, 
                edit: true, 
                remove: true, 
                winbox: false
            }, 
        }, 
    }, 
    {
        type: USER_TYPE.CUSTOMER, 
        permissions: {
            advancedSearch: false,
            station: {
                add: true, 
                edit: true, 
                remove: true, 
                winbox: false, 
            }
        }, 
    }, 
    {
        type: 'read', 
        permissions: {
            advancedSearch: false,
            station: {
                add: false, 
                edit: false, 
                remove: false, 
                winbox: false, 
            }
        }, 
    }, 
]

Object.freeze(USER_TYPE);
Object.freeze(PERMISSION_TYPE);
Object.freeze(LOGIN_VERSION);
Object.freeze(STATION_PERMISSIONS);